<div [formGroup]="form" kalDialogContent
     [kalLoading]="loading">

    <kal-form-field>
        <kal-input formControlName="NewPassword"
                   label="Nouveau mot de passe">
        </kal-input>
    </kal-form-field>

    <app-password-compliance *ngIf="isStrongPasswordRequired"
                             [control]="form.get('NewPassword')">
    </app-password-compliance>

    <kal-form-field>
        <kal-input formControlName="ConfirmNewPassword"
                   label="Confirmation du mot de passe">
        </kal-input>
    </kal-form-field>

    <p *ngIf="form.errors?.invalidmatchpassword"
       class="gup-U-color--red">
        Les mots de passe saisis sont différents
    </p>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        [disabled]="loading || form.invalid"
                        kalTheme="primary">
                Enregistrer
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="close()"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
